<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1" foot-clone>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
<!--      <template v-slot:cell(contractorName)="data">-->
<!--        <div @click="showDetail(data.item.contractorName)">{{ data.item.contractorName }}</div>-->
<!--      </template>-->
<!--      <template v-slot:cell(content)="data">-->
<!--        <div @click="showDetail(data.item.content)">{{ data.item.content }}</div>-->
<!--      </template>-->
      <template v-slot:cell(number)="data">
        {{ Number(data.item.number).toFixed(3) }}
      </template>
      <template v-slot:cell(price)="data">
        {{ Number(data.item.price).toFixed(2) }}
      </template>
      <template v-slot:cell(amount)="data">
        {{ Number(data.item.amount).toFixed(2) }}
      </template>
<!--      <template v-slot:cell(invoiceDutyRate)="data">-->
<!--        {{ Number(data.item.invoiceDutyRate).toFixed(2) }}-->
<!--      </template>-->
<!--      <template v-slot:cell(remarks)="data">-->
<!--        <div @click="showDetail(data.item.remarks)">{{ data.item.remarks }}</div>-->
<!--      </template>-->

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
      </template>
      <template v-slot:foot(index)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
      </template>
      <template v-slot:foot(number)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'number')}}</div>
      </template>
      <template v-slot:foot(amount)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'amount')}}</div>
      </template>
<!--      <template v-slot:foot(estimateAmount)="data">-->
<!--        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(items,'estimateAmount')}}</div>-->
<!--      </template>-->
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";

export default {
  name: "completionSettlementDetail",
  data(){
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'content', label: '施工内容', width: '170px'},
        {key: 'method', label: '结算方式', width: '160px'},
        {key: 'unit', label: '计量单位', width: '160px'},
        {key: 'number', label: '工程量', width: '120px'},
        {key: 'price', label: '单价（元）', width: '100px'},
        {key: 'amount', label: '结算金额（元）', width: '120px'},
      ],
      items: [],
      unitCategory: '',
    }
  },
  created(){
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init(){

    },
    goBack(){
      this.$router.back()
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass(){
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      let precision = 2
      if (key === 'number') {
        precision = 3
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(precision, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>